import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as TyreRepairOrderActions from './tyre-repair-order.action';
import { OrderService } from '../order/order.service';
import { TyreRepairOrderService } from './tyre-repair-order.service';
import * as TyreRepairOrderModels from '../../models/tyre-repair-order/tyre-repair-order';
import * as OrderStatusModels from '../../models/order/orderStatus';
import { TyreRepairOrderSearchModel } from '../../models/tyre-repair-order/tyre-repair-orderSearch';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { SaveState } from '../../models/commonModels';
import { BannerService } from '../../shared/services/banner.service';
import * as Models from '../../models/commonModels';
import { StorageService } from '../../shared/services/storage.service';

export interface TyreRepairOrderStateModel {
    OrderStatus: OrderStatusModels.OrderStatusListModel;
    OrderList: TyreRepairOrderModels.TyreRepairOrderListModel;
    Order: Models.Response<TyreRepairOrderModels.TyreRepairOrderModel>;
    Search: TyreRepairOrderSearchModel;
}

class DictionaryKeys {
  public static readonly OrderStatus = "TyreRepairOrderOrderStatus";
}


@State<TyreRepairOrderStateModel>({
  name: 'TyreRepairOrderState',
    defaults: {
      OrderStatus: null,
      OrderList: null,
      Search: null,
      Order: null
    }
  })

  @Injectable()

  export class TyreRepairOrderState {

    constructor(
      private helperService: HelperService,
      private tyreRepairOrderService: TyreRepairOrderService,
      private orderService: OrderService,
      private bannerService: BannerService,
      private storageService: StorageService
  ) { }


  @Selector()
  static OrderStatus(state: TyreRepairOrderStateModel) {
    return state.OrderStatus;
  }

  @Selector()
  static OrderList(state: TyreRepairOrderStateModel) {
    return state.OrderList;
  }

  @Selector()
  static Order(state: TyreRepairOrderStateModel) {
    return state.Order;
  }

  @Selector()
  static OrderSearch(state: TyreRepairOrderStateModel) {
    return state.Search;
  }

  @Action(TyreRepairOrderActions.GetList)
  GetList(
    context: StateContext<TyreRepairOrderStateModel>,
    action: TyreRepairOrderActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy zleceń naprawy opony.';

    context.setState(
      patch({
        OrderList: null
      })
    );

    this.tyreRepairOrderService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            OrderList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('OrderActions.GetList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(TyreRepairOrderActions.SetSearch)
  SetSearch(
    context: StateContext<TyreRepairOrderStateModel>,
    action: TyreRepairOrderActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreRepairOrderActions.GetList(action.Search));
  }

  @Action(TyreRepairOrderActions.SetListPage)
  SetListPage(
    context: StateContext<TyreRepairOrderStateModel>,
    action: TyreRepairOrderActions.SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreRepairOrderActions.GetList(action.Search));
  }

  @Action(TyreRepairOrderActions.ResetSearch)
  ResetSearch(
    context: StateContext<TyreRepairOrderStateModel>
  ) {

    const state = context.getState();

    const search = new TyreRepairOrderSearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new TyreRepairOrderActions.GetList(search));
  }

  @Action(TyreRepairOrderActions.GetStatusDictionary)
  GetStatusDictionary(
    context: StateContext<TyreRepairOrderStateModel>
  ) {

    const errorMessage = 'Błąd pobierania statusów zleceń naprawy opon.';

    let storageKey = DictionaryKeys.OrderStatus;

    context.setState(
      patch({
        OrderStatus: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.OrderStatus) {
      this.tyreRepairOrderService.getStatusDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              OrderStatus: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreRepairOrderActions.GetStatusDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreRepairOrderActions.DisposeSearch)
  DisposeSearch(
      context: StateContext<TyreRepairOrderStateModel>
    ) {

      context.setState(
        patch({
          Search: null
        }));
  }

  @Action(TyreRepairOrderActions.Set)
  Set(
    context: StateContext<TyreRepairOrderStateModel>,
    action: TyreRepairOrderActions.Set
  ) {
    const errorMessage = 'Błąd zapisu zmian zlecenia naprawy opon.';

    this.tyreRepairOrderService.set(action.Order).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zapisano zmiany do zlecenia naprawy opon ' + ret.Item.Number + '.');

          context.setState(
            patch({
              Order: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('TyreRepairOrderActions.Set', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreRepairOrderActions.Get)
  Get(
    context: StateContext<TyreRepairOrderStateModel>,
    action: TyreRepairOrderActions.Get
  ) {
    const errorMessage = 'Błąd odczytu szczegółów zlecenia naprawy opon.';

    this.tyreRepairOrderService.get(action.OrderId).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              Order: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('TyreRepairOrderActions.Get', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreRepairOrderActions.Create)
  Create(
    context: StateContext<TyreRepairOrderStateModel>,
    action: TyreRepairOrderActions.Create
  ) {
    const errorMessage = 'Błąd utworzenia zlecenia naprawy opon.';

    this.tyreRepairOrderService.create(action.Order).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Utworzono zlecenia naprawy opon ' + ret.Item.Number + '.');
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }

        context.setState(
          patch({
            Order: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('TyreRepairOrderActions.Create', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }
}

